<template lang="pug">
  .guide-filter-wrapper
    .guide-filter-link(@click="filtering(undefined)" :class="link_class(undefined)") Все гиды
    .guide-filter-link(
      v-for="(guide, i) in guides"
      :class="link_class(guide.id)"
      @click="filtering(guide)"
      ) {{ guide.name }}

</template>

<script>
export default {
  name: "GuideFilter",
  props: ['guides'],
  data() {
    return {
      selected_guide_id: undefined,
    }
  },
  methods:{
    link_class(id){
      return (this.selected_guide_id == id) ? 'active' : '';
    },
    filtering(guide){
      this.$set(this, 'selected_guide_id', (guide === undefined) ? undefined : guide.id)
      this.$emit('filter', guide);
    }
  }
}
</script>

<style scoped>

</style>